import { Injectable } from '@angular/core';

export class Club {
     id: number;
     postalCode: string;
     city: string;
     company: string;
     obId: number;
}

@Injectable()
export class SelectedClubService {
     private _club: Club;

     constructor() {
          this.setDefault();
     }

     set club(club) {
          this._club = club;
     }

     get club() {
          return this._club;
     }

     setDefault() {
          this._club = this.getDefault();
     }

     getDefault() {
          return Object.assign(window.app.club);
     }

     isExternal() {
          return this._club && this._club.id !== window.app.club.id;
     }

     reset() {
          this.setDefault();
     }
}
